import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { templateStatusesCriterionRoute } from './statuses/criterion.route';
import { templateStatusesListRoute } from './statuses/list.route';

export const templateStatusesRoute: RouteConfig = {
  path: 'statuses',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [templateStatusesListRoute, templateStatusesCriterionRoute],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'Statusy',
      name: 'templateEditStatuses'
    }
  },
  redirect: { name: 'templateEditStatuses' },
  beforeEnter(to, from, next) {
    store
      .dispatch('role/list', { count: -1 })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.ROLE_CANNOT_LIST }));
  }
};
